(function () {
    'use strict';
    // Directives used to organize our sidebar

    angular.module('GorillaBoy.directives')
    .directive('profilePanel', [
        '$rootScope',
        '$translate',
        'FeatureManagerService',
        'SessionManager',
        'SignalProvider',
        'RegionService',
        'LayoutManager',
        'Features',
        '$timeout',
        'SourceConstant',
        'AppConstants',
        'EndpointConfig',
        'EndpointService',
        '$filter',
        'DateFormatter',
        'UserService',
        'MessageManager',
        'localStorageService',
        'AuthService',
        '$location',
        'authenticatedUser',
        'MessageProvider',
        'ClientMetricsService',
        'MetricEvents',
        '$window',
        '$log',
        function ($rootScope,
            $translate,
            FeatureManagerService,
            SessionManager,
            SignalProvider,
            RegionService,
            LayoutManager,
            Features,
            $timeout,
            SourceConstant,
            AppConstants,
            EndpointConfig,
            EndpointService,
            $filter,
            DateFormatter,
            UserService,
            MessageManager,
            localStorageService,
            AuthService,
            $location,
            authenticatedUser,
            MessageProvider,
            ClientMetricsService,
            MetricEvents,
            $window,
            $log) {
        return {
            replace: true,
            scope: true,
            templateUrl: './top-nav/profile_panel.html',
            link: function (scope, element, attrs) {


                var userInfo = authenticatedUser.getUserInfo(),
                    StorageUtilizedInBytes = (userInfo ? userInfo.Storage.StorageUtilizedInBytes : 0),
                    StorageAllocatedInBytes = (userInfo ? userInfo.Storage.StorageRule.StorageAllocatedInBytes : 0),
                    DEFAULT_LOCALE = 'default',
                    TMP_IMG_EXPIRATION = 30000,
                    SkuTypes = AppConstants.SkuType;

                // AppConstant bindings
                scope.ViewTypes = AppConstants.ViewTypes;
                scope.DEFAULT_PROFILE_ICON = 'images/default.png';

                if ($rootScope.tmpImg) {
                   var expirationTime = $rootScope.tmpImg.expirationTime;
                    if (Date.now() - expirationTime > 0) {
                        $rootScope.tmpImg = null;
                    }
                }

                if (userInfo) {
                    scope.profile = {
                        Username: userInfo.Username,
                        EmailAddress: userInfo.EmailAddress,
                        userId: userInfo.Id,
                        organizationName: userInfo.Organization.Name,
                        organizationSubdomain: userInfo.Organization.Subdomain,
                        storage: userInfo.Storage,
                        storageUtilizedInBytes: StorageUtilizedInBytes,
                        storageAllocatedInBytes: StorageAllocatedInBytes,
                        submittedProfile: false,
                        submittedPassword: false
                    };

                    scope.givenName = function() {
                        return $rootScope.escapeHTML(userInfo.GivenName);
                    };

                    scope.surname = function() {
                        return $rootScope.escapeHTML(userInfo.Surname);
                    };

                    scope.largePhoto = function() {
                        return $rootScope.tmpImg ? $rootScope.tmpImg.dataURI : userInfo.ProfilePhotoMetadata.ProfilePhotoThumbnails.LARGE;
                    };

                    $translate('PROFILE.CHANGE_PHOTO_BUTTON').then(function(data) {
                        scope.profile.profileText = data;
                    });

                    scope.timeZone = {
                        timeZones: DateFormatter.timezones(),
                        timeZoneId: userInfo.TimeZoneId
                    };

                    scope.languageSettings = {
                        locale: (userInfo.Locale && userInfo.Locale !== null) ? userInfo.Locale : DEFAULT_LOCALE,
                        localeValues: getLocaleValues()
                    };
                }

                var anchorKeydownHandler = function(event) {
                    if (event.keyCode === AppConstants.KeyCodes.ENTER || event.keyCode === AppConstants.KeyCodes.SPACEBAR) {
                        // click on target when pressing enter and spacebar, 
                        // because calling scope.setTimeZone/setLocale here won't close the menu
                        $timeout(function() {
                            event.target.click();
                        }, 0);
                    }
                };

                var previousTimeZoneId, previousTimeZoneName;
                scope.getTimeZoneName = function(timeZoneId) {

                   // Avoid searhing in list all the time
                   if (angular.equals(previousTimeZoneId, timeZoneId)) {
                      return previousTimeZoneName;
                   }

                   var timeZoneName = "";
                   scope.timeZone.timeZones.forEach(function(zone){
                      if(zone.id === timeZoneId){
                        timeZoneName = '(UTC' + zone.offset + ')' + zone.id;
                      }
                   });

                   previousTimeZoneId = timeZoneId;
                   previousTimeZoneName = timeZoneName;

                   return timeZoneName;
                };

                scope.setTimeZone = function(timeZoneId) {
                  scope.timeZone.timeZoneId = timeZoneId;
                  scope.updateProfile('timezone');
                };

                scope.timezoneOptionsKeydownHandler = anchorKeydownHandler;

                scope.profilePhoto = {};

                var previousLocaleCode, previousLocaleName;
                scope.getLocaleName = function(localeCode) {

                  // Avoid searhing in list all the time
                  if (angular.equals(previousLocaleCode, localeCode)) {
                     return previousLocaleName;
                  }

                  var localeName = "";
                  scope.languageSettings.localeValues.forEach(function(locale){
                     if(locale.Code === localeCode){
                       localeName = locale.Locale;
                     }
                  });

                  previousLocaleCode = localeCode;
                  previousLocaleName = localeName;

                  return localeName;
                };

                scope.setLocale = function(localeCode) {
                  scope.languageSettings.locale = localeCode;
                  scope.updateProfile('language');
                };

                scope.localeOptionsKeydownHandler = anchorKeydownHandler;

                function getLocaleValues() {
                    var localeValues = angular.copy(AppConstants.LocaleValues),
                        defaultLocale = {};

                    defaultLocale.Code = DEFAULT_LOCALE;

                    if ($rootScope.siteLanguageLocale) {
                        angular.forEach(localeValues, function(locale) {
                            if (locale.Code === $rootScope.siteLanguageLocale) {
                                defaultLocale.Locale = $translate.instant('PROFILE.DEFAULT') + ' [' + locale.Locale + ']';
                            }
                        });
                    } else {
                        // site default language will pass 'default' to service
                        angular.forEach(localeValues, function(locale) {
                            if (locale.Code === userInfo.Organization.Locale) {
                                defaultLocale.Locale = $translate.instant('PROFILE.DEFAULT') + ' [' + locale.Locale + ']';
                            }
                        });
                    }

                    localeValues.unshift(defaultLocale);
                    return localeValues;
                }

                scope.updateProfilePhoto = function() {                    
                    scope.$broadcast(SignalProvider.Profile.UpdatePhotoUploadUrl);
                    // Let the click happens in the next digest loop. Otherwise, the click will happen during the digest process
                    // which will trigger another digest loop, which causes Error: inprog (https://docs.angularjs.org/error/$rootScope/inprog)
                    $timeout(function() {
                        $("#id_profile_photo").click();
                    }, 0);      
                };

                /**
                 * Define the change password url for Non Fed org and redirect it
                 */
                scope.redirectToChangePasswordUrl = function() {
                    scope.profile.submittedPassword = true;
                    UserService.getChangePasswordUrl()
                    .success(function(data) {
                        scope.profile.submittedPassword = false;
                        var changePasswordUrl = data.ChangePasswordUrl;
                        changePasswordUrl += '&redirect_uri=' + encodeURIComponent(EndpointService.oauth2CallbackEndpoint());

                        // Add the the current page as the state for the post change redirect.
                        var state = $location.path().replace(/^\//g, '');
                        SessionManager.setRedirectState(state);
                        window.location = changePasswordUrl;
                    })
                    .error(function(data) {
                        scope.profile.submittedPassword = false;
                        MessageManager.addErrorMessage(MessageProvider.profileUpdateFailDefault);
                    });
                };

                /**
                 * Define the change password url for Fed org and redirect it
                 */
                scope.redirectToLoginV2ChangePasswordUrl = function() {
                    var region, stage, appPrefix, changePasswordUrl, inPreview;
                    region = RegionService.getRegion();
                    stage = EndpointService.stageConfigKey(region);
                    inPreview = localStorageService.get(AppConstants.PreviewSite.PREVIEW_STORAGE_KEY);
                    appPrefix = EndpointService.appPrefix(stage, inPreview);

                    //Define the change password url based on the stage, region and inPreview status.
                    changePasswordUrl = EndpointService.loginV2ChangePasswordUrl(stage, inPreview) + '?sitename=' + encodeURIComponent(EndpointService.organization());
                    changePasswordUrl += '&site_redirect_path=' + encodeURIComponent(appPrefix + '/index.html#/authSuccess');

                    window.location = changePasswordUrl;
                    return;
                };

                /**
                 * Initiate the password change flow.
                 */
                scope.initiateChangePassword = function() {
                    if (localStorageService.get(AppConstants.AuthType.AUTH_TYPE) == AppConstants.AuthType.AUTH_TYPE_LOGINV2) {
                        //Redirect to new change password component for Fed org
                        scope.redirectToLoginV2ChangePasswordUrl();
                    } else {
                        scope.redirectToChangePasswordUrl();
                    }
                    return;
                };



                /**
                 * Updates the profile information (First Name, Last Name, Locale, and user attributes)
                 */
                scope.updateProfile = function(key) {
                    var postData = {};
                    if (key === 'timezone') {
                        postData.TimeZoneId = scope.timeZone.timeZoneId;
                    } else if (key === 'language') {
                        postData.Locale = scope.languageSettings.locale;
                    }

                    UserService.updateUser(scope.profile.userId, postData)
                    .success(function(data) {
                        AuthService.updateUserInfo(data.User);
                        SessionManager.setTimeZoneId(data.User.TimeZoneId);
                        $rootScope.$broadcast(SignalProvider.DateTime.ClearMemoizedDates);
                        MessageManager.addSuccessMessage(MessageProvider.profileUpdateSuccess);
                    })
                    .error(function() {
                        MessageManager.addErrorMessage(MessageProvider.profileUpdateFailDefault);
                    });

                    scope.profile.submittedProfile = false;
                };

                scope.$on(SignalProvider.Profile.PhotoUpdated, function(e, data) {
                    scope.profilePhoto = data.files[0];
                    scope.profile.profileText = $translate.instant('PROFILE.CHANGE_PHOTO_BUTTON');

                    var reader = new FileReader();
                    reader.onload = function(e) {
                        $rootScope.tmpImg = {
                            dataURI: e.target.result,
                            expirationTime: Date.now() + TMP_IMG_EXPIRATION
                        };

                        var img = $('<img>')
                            .attr('src', e.target.result)
                            .addClass('profile-panel-person-thumbnail').addClass('person-thumbnail-large');
                        $('#profile_photo').html(img);

                        /* Seems like the new left sidebar theme use icon instead of profile thumbnail.
                        var img_left_panel = $('<img>')
                            .attr('src', e.target.result)
                            .addClass('person-thumbnail').addClass('pull-left');
                        $('#profile_photo_left_panel').html(img_left_panel);
                        */
                    };
                    reader.readAsDataURL(scope.profilePhoto);

                    UserService.updateProfilePhoto(scope.profile.userId)
                    .success(function(data) {
                        AuthService.updateUserInfo(data.User);
                    })
                    .error(function() {
                        MessageManager.addErrorMessage(MessageProvider.profileUpdateFailDefault);
                    });
                });

                function logoutResultHandler (data) {
                    // Clear the cookie based session.
                    SessionManager.logout();
                    // Navigate to the login page and clear the history.
                    if (localStorageService.get(AppConstants.AuthType.AUTH_TYPE) == AppConstants.AuthType.AUTH_TYPE_LOGINV2) {
                        // logout is managed by Loginv2 pages. So go there.
                        scope.redirectToLoginV2LogoutUrl();
                    } else {
                        $location.path('/login');
                    }
                }

                scope.getFullname = function(user) {
                    return $rootScope.getFullName(user);
                };

                scope.isPreviewEnabled = function() {
                    var featureEnabledState = FeatureManagerService.isFeatureEnabled(Features.UI.PREVIEW_SITE) || false,
                        region = RegionService.getRegion(),
                        isProd,
                        stage;

                    stage = EndpointConfig.stage(region);
                    isProd = stage === "PROD";
                    return isProd && featureEnabledState;
                };

                scope.authenticated = AuthService.isAuthenticated() && !scope.layout.isAnonymous;
                scope.isPreviewSite = EndpointConfig.isPreviewSite();

                scope.logout = function () {
                    AuthService.logout()
                    .finally(logoutResultHandler);
                };

                scope.isMinimalUser = function(){
                  return FeatureManagerService.isFeatureEnabled(Features.UI.EXTERNAL_SHARE) && userInfo && userInfo.MinimalUser;
                };

                scope.isAdmin = function() {
                    return userInfo && userInfo.Administrator;
                };

                scope.showAdminText = function() {
                    return "Role: Admin";
                };

                scope.isBasicUser = function() {
                    return userInfo && userInfo.SkuType === SkuTypes.BASIC;
                };

                scope.sitename = function() {
                    var orgName = userInfo ? userInfo.Organization.Name : "";                    
                    return orgName;
                };

                scope.setTabIndex = function() {
                    if( scope.$parent.isProfilePanelOpen ) {
                        // By setting tabindex to "0", elements are reachable via keyboard. 
                        // More info: https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
                        return 0; 
                    }
                    return -1; // By setting tabindex to "-1", elements are not reachable via keyboard.
                };

                scope.profilePanelDoneKeyDown = function (e) {
                    if (e.keyCode === AppConstants.KeyCodes.ENTER || e.keyCode === AppConstants.KeyCodes.SPACEBAR) {
                        scope.closeProfilePanel();
                    } 
                };

                scope.closeProfilePanel = function() {
                    scope.$parent.isProfilePanelOpen = false;
                    angular.element('#avatar').focus();
                };

                /**
                 * Register Focus Trap for profile panel. 
                 * 
                 * Register listener for keydown event, when TAB on last focusable element, set focus to first focusable element;
                 * when SHIFT+TAB on first focusable element, set focus to last focusable element;
                 * 
                 * By doing this, only elements in profile panel are reachable via keyboard when profile panel is opened.
                 * 
                 * Reference: https://toreaurstad.blogspot.com/2019/11/angularjs-directive-for-focus-trap-for.html
                 */
                scope.registerFocusTrap = function (element) {
                    var KEYCODE_TAB = 9;
                
                    $(element).on('keydown',
                        function (e) {
                            var focusableEls = element.querySelectorAll('[tabindex="0"]'); // All focusable elements in profile panel;
                            var firstFocusableEl = focusableEls[0];
                            var lastFocusableEl = focusableEls[focusableEls.length - 1];
                            var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
                
                            if (!isTabPressed) {
                                return;
                            }
                
                            if (e.shiftKey) { // shift + tab
                                if (document.activeElement === firstFocusableEl) {
                                    lastFocusableEl.focus(); 
                                    e.preventDefault();
                                }
                            } else  { // tab
                                if (document.activeElement === lastFocusableEl) {
                                    firstFocusableEl.focus();
                                    e.preventDefault();
                                }
                            }
                        }
                    );
                };
                
                for (var i = 0; i < element.length; i++) {
                    scope.registerFocusTrap(element.get(i));
                }
            }
        };
    }]);
}());


